import { FC } from 'react';
import { generalHthHelper } from '@monorepo/helpers';
import { houseToHouseServices } from 'src/services';
import { HTHItemCard } from './commons/HTHItemCard';
import { setAlertResponse, setValuesAndOpenAlertModalReducer } from 'src/store';
import { typeDoNotCall, typeHTHFace, typeTerritoryNumber } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetConfig } from 'src/custom-hooks';

type propsType = {
    currentFace: typeHTHFace;
    doNotCall: typeDoNotCall;
    territoryNumber: typeTerritoryNumber;
};

export const HTHDoNotCallsItem: FC<propsType> = ({ currentFace, doNotCall, territoryNumber }) => {
    const config = useGetConfig();
    const dispatch = useDispatch();

    const deleteHandler = (): void => {
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'confirm',
            title: '¿Eliminar No Tocar?',
            message: `Se va a eliminar este No Tocar de la Manzana ${generalHthHelper.MaskTheBlock(currentFace.block, config.isUsingLettersForBlocks)}, cara ${generalHthHelper.MaskTheFace(currentFace.face, config.isUsingLettersForBlocks)}: ${currentFace.street} ${doNotCall.streetNumber} ${doNotCall.doorBell}`,
            execution: deleteConfirmedHandler
        }));
    }

    const deleteConfirmedHandler = async (): Promise<void> => {
        const response = await houseToHouseServices.DeleteDoNotCall(territoryNumber, currentFace.block, currentFace.face, doNotCall.id);
        if (!response.success) {
            dispatch(setAlertResponse({ response }));
            return;
        }
    }

    return (
        <HTHItemCard
            creatorId={doNotCall.creatorId}
            date={doNotCall.date}
            deleteHandler={deleteHandler}
            text={`${currentFace.street} ${doNotCall.streetNumber} ${doNotCall.doorBell}`}
        />
    );
}
